import { FileSearchOutlined, StarFilled } from '@ant-design/icons';
import { Flex, Typography } from 'antd';

import styles from './ListNameRenderer.module.scss';

export default function ListNameRenderer({
  name,
  record,
} : {
  name: string;
  record: any;
}) {
  return (
    <Flex gap="small">
      {
        record.list_type === 'starred' ? (
          <StarFilled className={styles.starIcon} />
        ) : (
          <FileSearchOutlined className={styles.fileIcon} />
        )
      }
      <Typography.Link href={`/lists/${record.key}`} target="_blank">
        {name}
      </Typography.Link>
    </Flex>
  );
}
